export default (theme) => ({
    root: {
        display: 'flex',
        marginBottom: 16,
    },

    size: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        marginRight: 16,
        '&:hover:not($selected)': {
            cursor: 'pointer',
            '& $icon': {
                backgroundColor: theme.colors.grey[100],
                '& path': {
                    fill: theme.colors.actionMinor[500],
                },
            },
        },
    },
    icon: {
        width: 48,
        height: 48,
        borderRadius: 6,
        marginBottom: 8,
        willChange: 'background-color',
        transition: '0.1s background-color',
    },
    selected: {
        '& $icon': {
            backgroundColor: theme.colors.actionMajor[50],
            '& path': {
                fill: theme.colors.actionMajor[500],
            },
        },
    },
    text: {},
    input: {
        alignItems: 'start',
    },
});
